import { US1_TEST1_HOSTS } from '@fleet/environment';
import { FLEET_VERSION } from '@fleet/version';

export const environment = {
  production: true,
  hmr: false,
  version: FLEET_VERSION,
  minTokenExpiry: 60,
  fleetProduct: 'TRAVELLER',
  envName: 'test1-us1',

  ...US1_TEST1_HOSTS,
};
